import { useContext } from "react";
import { CheckboxProps as AriaCheckboxProps } from "react-aria-components";

import { _Checkbox } from "./assets/_Checkbox";
import { CheckboxGroupContext } from "./checkbox-group/CheckboxGroup";
import { Stack } from "../../../foundations/grid-layout/Stack";
import { _Text } from "../../_assets/_Text";
import {
  FieldErrorsProps,
  FieldErrors,
} from "../_assets/input-wrapper/FieldErrors";
import { LabelAlign } from "../../types";

export interface CheckboxProps extends Omit<AriaCheckboxProps, "style"> {
  children: string | React.ReactNode;
  errors?: FieldErrorsProps["children"];
  description?: string;
  testID: string;
  isCard?: boolean;
  noBorder?: boolean;
  style?: "default" | "subtle";
  isInvalid?: boolean;
  labelAlign?: LabelAlign;
}

export function Checkbox(props: CheckboxProps) {
  const {
    errors,
    children,
    description,
    style: textStyle = "default",
    isCard,
    testID,
    noBorder,
    labelAlign,
    ...checkboxProps
  } = props;
  const { isGroup, isCard: groupIsCard } = useContext(CheckboxGroupContext);

  return (
    <Stack gap="space-1">
      <_Checkbox
        isInvalid={props.isInvalid}
        noBorder={noBorder}
        {...checkboxProps}
        isCard={isCard || groupIsCard}
        data-testid={`${testID}-checkbox`}
        labelAlign={labelAlign}
      >
        <_Text
          style={textStyle === "subtle" ? "form/body-secondary" : "input/label"}
        >
          {children}
        </_Text>
        {description && (
          <_Text style="input/helper" color="text-weak" slot="description">
            {props.description}
          </_Text>
        )}
      </_Checkbox>
      {!isGroup && <FieldErrors>{errors}</FieldErrors>}
    </Stack>
  );
}
